<template>
  <div>
    <cac-page
      v-if="hasAdvocate"
      has-sidebar>
      <template slot="pre-content">
        <div class="mb-4 d-md-none">
          <officials-page-toggle large-buttons/>
        </div>

        <fixed-sidebar>
          <cac-page-header
            slot="header"
            :title="$t('cac.app.elected_officials')"
          />

          <officials-filter v-model="filters" />
        </fixed-sidebar>
      </template>

      <div class="officials-filtered-content col">
        <officials-results 
          :filters="filters" 
          :stakeholder-type="stakeholderType"
        />
      </div>
    </cac-page>
    <elected-officials-banner v-else/>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CacPage from "CivicActionCenterComponents/layout/CACPage.vue";
import CacPageHeader from "CivicActionCenterComponents/layout/CACPageHeader.vue";
import STATE from "Constants/campaign/civicactioncenter/state";
import STAKEHOLDER_TYPES from "Constants/campaign/civicactioncenter/stakeholderTypes";
import ElectedOfficialsBanner from "CivicActionCenterComponents/sections/ElectedOfficials/ElectedOfficialsBanner.vue";
import FixedSidebar from "CivicActionCenterComponents/shared/FixedSidebar.vue";
import OfficialsFilter from "CivicActionCenterComponents/shared/OfficialsFilter.vue";
import OfficialsResults from "CivicActionCenterComponents/shared/OfficialsResults.vue";
import OfficialsPageToggle from "CivicActionCenterComponents/shared/OfficialsPageToggle.vue";
import PARTIES from "Constants/campaign/civicactioncenter/parties";

const hasAdvocate = `${STATE.SCOPE_CAC}/${STATE.HAS_ADVOCATE}`;

export default {
  name: "ElectedOfficials",
  components: {
    CacPage,
    CacPageHeader,
    ElectedOfficialsBanner,
    FixedSidebar,
    OfficialsFilter,
    OfficialsResults,
    OfficialsPageToggle
  },
  data() {
    return {
      filters: {
        party: PARTIES.ANY_PARTY
      },
      stakeholderType: STAKEHOLDER_TYPES.ELECTED_OFFICIAL
    };
  },
  computed: {
    ...mapGetters({
      hasAdvocate
    })
  }
};
</script>
